// Remembers a personal (profile) invite code across the sign-up journey, so someone who opens
// a /r/<code> link WITHOUT an account still credits the inviter after they register, verify,
// and sign in — even if that final sign-in happens in a fresh tab. Mirrors pendingJoin (circle
// codes) but is redeemed via /auth/invite/redeem instead of joining a circle. Cleared once the
// redeem resolves (credited or definitively not).
const KEY = 'ss_pending_referral';

export const setPendingReferral = (code) => {
  try { if (code) window.localStorage.setItem(KEY, String(code).toUpperCase()); } catch { /* storage blocked */ }
};

export const getPendingReferral = () => {
  try { return window.localStorage.getItem(KEY); } catch { return null; }
};

export const clearPendingReferral = () => {
  try { window.localStorage.removeItem(KEY); } catch { /* storage blocked */ }
};
